import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const navLink = ({ isActive }) =>
  `text-xs uppercase tracking-[0.2em] transition-colors ${
    isActive ? "text-[var(--brand-red)]" : "text-[var(--emerald)] hover:text-[var(--brand-red)]"
  }`;

/**
 * Toggle to expose Properties / JT.Jewels / Hosts in the public nav.
 * Hidden by default during the soft launch — flip to true (or set
 * `REACT_APP_SHOW_TRAVEL_NAV=1` in frontend/.env) to restore them
 * without a code edit.
 */
const SHOW_TRAVEL_NAV =
  String(process.env.REACT_APP_SHOW_TRAVEL_NAV || "").toLowerCase() === "true" ||
  process.env.REACT_APP_SHOW_TRAVEL_NAV === "1";

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="w-full border-b border-[var(--emerald)]/10 bg-[var(--ivory)]/80 backdrop-blur-md sticky top-0 z-40"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-3 flex items-center justify-between gap-6">
        <nav className="hidden md:flex items-center gap-6 lg:gap-8">
          <NavLink to="/" end className={navLink} data-testid="nav-chat">Travel with Sasha</NavLink>
          <NavLink to="/hosts" className={navLink} data-testid="nav-hosting">Host with Sasha</NavLink>
          {SHOW_TRAVEL_NAV && (
            <>
              <NavLink to="/stays" className={navLink} data-testid="nav-stays">Properties</NavLink>
              <NavLink to="/jewel-store" className={navLink} data-testid="nav-jewel-store">
                <span
                  style={{
                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                    fontStyle: "italic",
                    fontWeight: 600,
                    fontSize: "1.85rem",
                    letterSpacing: "0.02em",
                    lineHeight: 1,
                    textTransform: "none",
                  }}
                >
                  JT.Jewels
                </span>
              </NavLink>
            </>
          )}
          <NavLink to="/join" className={navLink} data-testid="nav-join">Club Janté</NavLink>
          {user ? (
            <button
              onClick={() => {
                logout();
                navigate("/");
              }}
              className={`text-xs uppercase tracking-[0.2em] text-[var(--emerald)] hover:text-[var(--brand-red)] transition-colors`}
              data-testid="nav-logout-btn"
            >
              Sign out
            </button>
          ) : (
          <NavLink to="/guest-signin" className={navLink} data-testid="nav-login-btn">Sign in</NavLink>
          )}
          <NavLink to="/tenant-thrive" className={navLink} data-testid="nav-tenant-thrive">Tenant Thrive</NavLink>
        </nav>

        <div className="ml-auto" />
      </div>
    </header>
  );
}
